module.exports = __webpack_public_path__ + "static/media/36_B.2f426bf0.png";